/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RecentlyJoinedGroupedMonth = {
    properties: {
        month: {
    type: 'number',
    isRequired: true,
},
        employees: {
    type: 'array',
    contains: {
        type: 'AnniversaryEmployeeInfo',
    },
    isRequired: true,
},
    },
};